import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import CompanyEmailLog from "@/interfaces/CompanyEmailLog";
import api from "../api";

export const companyEmailsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyEmails: build.query<
      IPaginateResponse<CompanyEmailLog>,
      [string, IFilters]
    >({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${id}/emails`,
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyEmails" as const,
                id,
              })),
              { type: "CompanyEmails", id: "LIST" },
            ]
          : [],
    }),
    sendCompanyBrochures: build.mutation<
      CompanyEmailLog,
      [string, { brochureIds: string[]; templateId: string; programmes?: Array<{ label: string; url: string }> }]
    >({
      query: ([id, body]) => ({
        url: `/companies/${id}/emails/send-brochures`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId]) => [
        { type: "CompanyEmails", companyId },
      ],
    }),
    getCompanyEmail: build.query<CompanyEmailLog, [string, string]>({
      query: ([companyId, emailId]) => ({
        url: `/companies/${companyId}/emails/${emailId}`,
      }),
      providesTags: (_result, _error, [_companyId, emailId]) => [
        { type: "CompanyEmails", id: emailId },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyEmailsQuery,
  useSendCompanyBrochuresMutation,
  useGetCompanyEmailQuery,
} = companyEmailsApi;
